import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { history } from './history';
import reportWebVitals from './reportWebVitals';
import { AppContainer } from './modules/app/app.container';
import { AppContextProvider } from './contexts/app/app.context';
import { LeadContextProvider } from './contexts/lead/lead.context';
import { GoalContextProvider } from './contexts/goal/goal.context';
import { RiskContextProvider } from './contexts/risk/risk.context';
import { AppApi } from './apis/app.api';
import { LocalStorageUtils } from '@assetmark/ui-kit/dist/utils/local-storage.utils';
import { EXTERNAL_USER_ID } from './constants/storage.constant';
import { ErrorPage } from './modules/errorPage/errorPage.component';
import { clearLocalData } from './helpers/storage.helper';

const params = new URLSearchParams(document.location.search.substring(1));
const externalUserId = params.get('id');

const requestOptions = {
	method: 'POST',
	headers: { 'Content-Type': 'application/json' } 
};

const Main = () => 	<React.StrictMode>
		<AppContextProvider>
			<RiskContextProvider>
				<GoalContextProvider>
					<LeadContextProvider>
						<AppContainer history={history} />
					</LeadContextProvider>
				</GoalContextProvider>
			</RiskContextProvider>
		</AppContextProvider>
	</React.StrictMode>;

const root = document.getElementById('root');

const render = (externalUserId: string | null) => {
	//let container = <div>initial loading</div>;
	const previouslySavedUserId = LocalStorageUtils.getItem<string>(EXTERNAL_USER_ID);
	if (externalUserId) {
		fetch(`/public/wb/auth/${externalUserId}`, requestOptions)
			//.then(res => res.json())
			.then(data => {
				console.log(`Response From Public/WB/Auth:  `, data);
				if (data.status === 200) {
					if (previouslySavedUserId.isSome()) {
						// check if curremtUserId and savedUserId are not same then clear the local storage
						if(previouslySavedUserId.getOrElse("") !== externalUserId) {
							clearLocalData();
						}
					}
					AppApi.isAuthCallComplete$.next(true);
					LocalStorageUtils.setItem(EXTERNAL_USER_ID)(externalUserId);
					ReactDOM.render(<Main />, root);
				} else {
					// show error page if externalUserId is not valid
					if (process.env.NODE_ENV !== 'production') {
						// this check is only for local development mode.
						ReactDOM.render(<Main />, root);
						AppApi.isAuthCallComplete$.next(true);
					} else {
						ReactDOM.render(<ErrorPage />, root);
					}
				}
			})
			.catch(err => {
				console.log(`Error From Public/WB/Auth:`, err);
				if (process.env.NODE_ENV !== 'production') {
					// this check is only for local development mode.
					ReactDOM.render(<Main />, root);
					AppApi.isAuthCallComplete$.next(true);
				}
			});
	} else {
		if (previouslySavedUserId.isSome()) {
			AppApi.isAuthCallComplete$.next(true);
			ReactDOM.render(<Main />, root);
		}
	}
};

if (process.env.NODE_ENV !== 'production') {
	render("abc");
} else {
	render(externalUserId);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
